import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxBarcodeModule } from 'ngx-barcode';
import { RedeemPartnerDialog } from './redeem-partner-dialog';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    NgxBarcodeModule,
  ],
  declarations: [RedeemPartnerDialog],
})
export class RedeemPartnerDialogModule {}
